module.exports = __webpack_public_path__ + "assets/img/thumb-AquavistaGlass-Website.a5fabeac.webp";